module.exports = "<div class=\"background\"></div>\n\n<div class=\"outer-container\">\n  \n  <div class=\"heading\">\n    <div class=\"spacer\">www</div>\n    <h1>Pumping up the tyres and oiling the chain</h1>\n    <h2>\n      We're doing some required maintenance at the moment, but we'll be back with you in no time.\n    </h2>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/maintenance/maintenance.component.html
// module id = ../../../../../src/app/maintenance/maintenance.component.html
// module chunks = main